export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-guide-dog-e8ffa45a7b4920b33f17846378dcb73a.svg";